import { IJSONOutEmail } from "../../server/jsons/out/JSONOutEmail";
import InputValidationResult from "./InputValidationResult";

interface IProps {
  json: IJSONOutEmail
}

export default class Email {
  public static getFactory(props: IProps): Email {
    return new Email({ json: props.json });
  }

  public getJson(): IJSONOutEmail | null {
    try {
      return this.props!!.json;
    } catch (e) {
      return null;
    }
  }

  public get isNew(): boolean {
    return true;
  }

  //#region dirtyData
  private _hasDirtyData: boolean = false;
  public setHasDirtyData(it: boolean = true) {
    this._hasDirtyData = it;
  }
  public resetDirtyData() {
    this._hasDirtyData = false;
  }
  public get hasDirtyData(): boolean {
    return this._hasDirtyData;
  }
  //#endregion

  //#region isValid
  private resetIsValid() {
    this.subjectVR.reset();
    this.senderNameVR.reset();
    this.senderVR.reset();
    this.messageVR.reset();
  }

  private _isValid: boolean = false;
  public get isValid(): boolean {
    return this._isValid;
  }
  private setIsValid() {
    this._isValid = this.getIsValid();
  }
  private getIsValid(): boolean {
    try {
      if (!this.subjectVR.isValid) return false;
      if (!this.senderNameVR.isValid) return false;
      if (!this.senderVR.isValid) return false;
      if (!this.messageVR.isValid) return false;
      return true;
    } catch (e) {
      return false;
    }
  }
  //#endregion

  //#region readonly props
  //public get recipient(): string | undefined { try { return this.getJson()!!.recipient!!; } catch (e) { return undefined; } }
  //#endregion

  constructor(private props: IProps) {}

  //subject
  public subjectVR = InputValidationResult.getItem({
    onSetValue: () => this.setIsValid(),
  });
  private _subject: string | null = null;
  public get subject(): string | undefined {
    try {
      return this.getJson()!!.subject!!;
    } catch (e) {
      return undefined;
    }
  }
  public set subject(it: string | null) {
    try {
      this._subject = it;
      this.isNew && this._subject != null
        ? (this.getJson()!!.subject = this._subject)
        : null;
      this.setHasDirtyData();
    } catch (e) {}
  }
  public get subjectDirty(): string | null {
    return this._subject;
  }

  //sender
  public senderVR = InputValidationResult.getItem({
    onSetValue: () => this.setIsValid(),
  });
  private _sender: string | null = null;
  public get sender(): string | undefined {
    try {
      return this.getJson()!!.sender!!;
    } catch (e) {
      return undefined;
    }
  }
  public set sender(it: string | null) {
    try {
      this._sender = it;
      this.isNew && this._sender != null
        ? (this.getJson()!!.sender = this._sender)
        : null;
      this.setHasDirtyData();
    } catch (e) {}
  }
  public get senderDirty(): string | null {
    return this._sender;
  }

  //senderName
  public senderNameVR = InputValidationResult.getItem({
    onSetValue: () => this.setIsValid(),
  });
  private _senderName: string | null = null;
  public get senderName(): string | undefined {
    try {
      return this.getJson()!!.senderName!!;
    } catch (e) {
      return undefined;
    }
  }
  public set senderName(it: string | null) {
    try {
      this._senderName = it;
      this.isNew && this._senderName != null
        ? (this.getJson()!!.senderName = this._senderName)
        : null;
      this.setHasDirtyData();
    } catch (e) {}
  }
  public get senderNameDirty(): string | null {
    return this._senderName;
  }

  //message
  public messageVR = InputValidationResult.getItem({
    onSetValue: () => this.setIsValid(),
  });
  private _message: string | null = null;
  public get message(): string | undefined {
    try {
      return this.getJson()!!.message!!;
    } catch (e) {
      return undefined;
    }
  }
  public set message(it: string | null) {
    try {
      this._message = it;
      this.isNew && this._message != null
        ? (this.getJson()!!.message = this._message)
        : null;
      this.setHasDirtyData();
    } catch (e) {}
  }
  public get messageDirty(): string | null {
    return this._message;
  }
}